<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="23"
    viewBox="0 0 16 13"
  >
    <g transform="translate(0)">
      <path
        class="svg-primary"
        d="M7.446,14a.357.357,0,0,0-.315.362v1.986H4.348a.355.355,0,0,0-.348.36v8.4a1.967,1.967,0,0,0,.575,1.362A1.823,1.823,0,0,0,5.913,27H18.2a1.753,1.753,0,0,0,1.289-.551A1.893,1.893,0,0,0,20,25.1V14.358A.355.355,0,0,0,19.651,14Zm.38.722H19.3V25.1a1.092,1.092,0,0,1-.288.858,1.007,1.007,0,0,1-.82.316H7.386a1.827,1.827,0,0,0,.44-1.174Zm1.881,1.625a.357.357,0,0,0-.315.362v3.249a.355.355,0,0,0,.347.362h7.652a.355.355,0,0,0,.348-.361V16.71a.355.355,0,0,0-.347-.362H9.707ZM4.7,17.069H7.129V25.1A1.155,1.155,0,0,1,6.006,26.27l-.033.006h-.06a1.1,1.1,0,0,1-.856-.309A1.193,1.193,0,0,1,4.7,25.1Zm5.391,0h6.956V19.6H10.087Zm-.38,4.695a.362.362,0,0,0,.033.722h7.652a.345.345,0,0,0,.315-.175.373.373,0,0,0,0-.371.345.345,0,0,0-.315-.175Zm0,2.166a.362.362,0,0,0,.033.722h7.652a.345.345,0,0,0,.315-.175.373.373,0,0,0,0-.371.345.345,0,0,0-.315-.175Z"
        transform="translate(-4 -14)"
      />
    </g>
  </svg>
</template>
<script>
export default {};
</script>
